import "@app/pages/Individual/invoice/invoicemain.scss";
import "@app/style/dx.generic.catetory-chooser-compact.css";
import "./invoicegrid.scss";

import { useCallback, useRef } from "react";
import { isSameDay } from "date-fns";
import DataGrid, {
  Button,
  Column,
  ColumnChooser,
  Editing,
  FilterPanel,
  // FilterBuilderPopup,
  Grouping,
  GroupItem,
  GroupPanel,
  HeaderFilter,
  Item,
  LoadPanel,
  Paging,
  RemoteOperations,
  Scrolling,
  SearchPanel,
  Selection,
  StateStoring,
  Summary,
  Toolbar,
  TotalItem,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { run, sleep } from "effection";
import sum from "hash-sum";
//
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { callFXMLDetailsForm } from "@app/statefx/xThunks/uiSpvMain";
import { fieldDefs } from "@app/components/lists/lxr_common_definitions";
import { PERSISTOR_NAME } from "@app/state/constants";
import {
  calculateTotalValuesConv,
  CurrencyPickerOpts,
  EmitentPickerOpts,
  groupCustomItem,
  groupCustomItemConv,
  groupCustomTotals,
  groupCustomTotalsConv,
  totalsCount,
} from "@app/components/lists/lxr_common_elements";
import { useWindowDimensions } from "@app/contexts";
import * as appConst from "@app/state/constants";
import { fxDispatch, useFxDispatch, useFxSelector } from "@app/statefx";
import { schema } from "@app/statefx/schema";
// import { createLocalStorageAdapter, select } from "starfx";
// import { selectorWorkerGxDBName } from "@app/statefx/selectors/app.sel";
import { selectToolbarForInvoiceOverall } from "@app/statefx/selectors/invoiceOverall.sel";
import { select_apiProf_issuersArray } from "@app/statefx/selectors/invoiceIssuers.sel";
import { selectInvoiceDataOverall } from "@app/statefx/selectors/invoiceOverall.sel";
import { selectFxFilterRange } from "@app/statefx/selectors/uiMonthTree";
import { fxSelectInvoiceTab } from "@app/statefx/xThunks/uiInvoiceOverall";
import { sfxPreserveTrackState } from "@app/statefx/xThunks/uiInvoiceTree";
import { fxSelectInvoiceTabWithPayload } from "@app/statefx/xThunks/uiInvoiceOverall";
import { sfxNotify } from "@app/statefx/xThunks/notify";
import {
  setCurrentInvoiceMain,
  setCurrentInvoiceMain2,
  setViewToCurrentMonth,
} from "@app/statefx/xThunks/uiInvoiceOverall";

import { isCurrentMonthSelected } from "@app/statefx/selectors/uiMonthTree";
import { sendStorageRequest } from "@app/statefx/gridpersistor";

import type { TCurrency } from "@app/types";
import type { Operation } from "effection";
import type { DataGridRef, DataGridTypes } from "devextreme-react/data-grid";

// import { triggerSync } from "@app/index";
const filterBuilderPopupPosition = {
  of: window,
  at: "top" as const,
  my: "top" as const,
  offset: { y: 10 },
};

const formatDate = (x) => {
  try {
    return new Date(x).toLocaleDateString("ro-RO");
  } catch (e) {
    console.log("err #410: ", e, "at formatDate for ", x);
    return x;
  }
};

// function sendStorageRequest(pName, storageKey, method, data = null) {
//   return new Promise((resolve, reject) => {
//     if (method === "GET") {
//       try {
//         const state = window.fx.getState();
//         const data = state[storageKey];
//         if (data) {
//           resolve(data || {});
//         } else {
//           resolve({});
//         }
//       } catch (error) {
//         reject(error); // Reject the promise in case of error
//       }
//     } else if (method === "PUT") {
//       try {
//         fxDispatch(setIvTrackGridPersistor(data));
//         resolve(true); // Resolve the promise on success
//       } catch (error) {
//         reject(error); // Reject the promise in case of error
//       }
//     } else {
//       // Handle other methods or throw an error
//       reject(new Error(`Method ${method} is not supported`));
//     }
//   });
// }

const idbName = PERSISTOR_NAME;

export const InvoiceOverall = () => {
  const { t } = useTranslation();
  const dispatch = useFxDispatch();
  const { jgDrawerHeight, appIsPersonalKarma } = useWindowDimensions();
  const hrrref = useRef<string>("dx-button-group-homeresetfilters");

  const groupKey = useRef<string[]>([]);
  const ivTrackGridRef = React.useRef<DataGridRef>(null);

  const theToolbarState = useFxSelector(selectToolbarForInvoiceOverall);
  const currencies = useFxSelector(schema.currencies.select);
  const issuers = useFxSelector(select_apiProf_issuersArray);
  const dataset = useFxSelector(selectInvoiceDataOverall);
  const reff = useFxSelector(selectFxFilterRange);
  const isHomeInInterval = useFxSelector(isCurrentMonthSelected);
  const reference0 = useMemo(() => sum(reff), [JSON.stringify(reff)]);

  const toolbarSwitchColorizedMemo = useMemo(
    () => theToolbarState.colorized,
    [theToolbarState.colorized]
  );

  const sumDataset = useMemo(() => sum(dataset), [dataset]);
  const dataSource = useMemo(
    () =>
      new DataSource({
        store: new CustomStore({
          key: "FF_ID",
          load: async () => {
            return dataset;
          },
          totalCount: async () => {
            return dataset.length;
          },
        }),
      }),
    [sumDataset]
  );

  function collapseTree(node?: number) {
    if (ivTrackGridRef.current?.instance) {
      if (node) {
        ivTrackGridRef.current.instance().collapseRow(node);
      } else ivTrackGridRef.current.instance().collapseAll();
    }
  }

  function* eDispatchDatasetChange({
    colorized,
    selectedCIF,
    currentCurrency,
    trackCollectionFilter,
  }: {
    colorized: boolean;
    selectedCIF: string;
    currentCurrency: TCurrency;
    trackCollectionFilter: "ALL" | "COLLECTED" | "UNCOLLECTED";
  }) {
    if (ivTrackGridRef.current?.instance) {
      ivTrackGridRef.current.instance().beginUpdate();
      if (
        colorized !== theToolbarState.colorized ||
        currentCurrency !== theToolbarState.currentCurrency ||
        selectedCIF !== theToolbarState.selectedCIF ||
        trackCollectionFilter !== theToolbarState.trackCollectionFilter
      ) {
        // save in redis the current selection
        dispatch(
          sfxPreserveTrackState({
            colorized: colorized,
            selectedCIF: selectedCIF,
            currentCurrency: currentCurrency,
            trackCollectionFilter: trackCollectionFilter,
          })
        );
      }
      yield* sleep(1);
      ivTrackGridRef.current.instance().endUpdate();
    }
  }

  const onEmitentChanged = useCallback(
    (e: any) => {
      const { selectedItem } = e;
      if (selectedItem) {
        const nextState = {
          ...theToolbarState,
          selectedCIF: selectedItem.CIF,
        } as any;
        run(() => eDispatchDatasetChange(nextState));
      }
    },
    [theToolbarState.selectedCIF]
  );

  const onCurrencyChanged = useCallback(
    (e: any) => {
      const { selectedItem } = e;
      if (selectedItem) {
        const nextState = {
          ...theToolbarState,
          currentCurrency: selectedItem,
        } as any;
        run(() => eDispatchDatasetChange(nextState));
      }
    },
    [theToolbarState.currentCurrency]
  );

  const onColorizeSwitchChanged = useCallback(
    async (e: any) => {
      const value = !theToolbarState.colorized;
      const nextState = {
        ...theToolbarState,
        colorized: value,
      } as any;
      await run(() => eDispatchDatasetChange(nextState));
    },
    [theToolbarState.colorized]
  );

  const colorizedOptions = {
    // id: "colorize_grid",
    width: 26,
    items: [
      {
        icon: "palette",
        hint: t("colorized"),
        key: "colorized",
      },
    ],
    keyExpr: "key",
    selectedItemKeys: [toolbarSwitchColorizedMemo ? "colorized" : "monochrome"],
    onItemClick: onColorizeSwitchChanged,
  };

  const calculateConvValue = useCallback(
    (e: any, targetField: string) => {
      // console.log('targetField', targetField)
      // we made all the conversions in the selctor, so we just return the value
      // perhaps we should do them in worker thread, but for now it's ok
      const { currentCurrency } = theToolbarState;
      if (!currentCurrency) return e[targetField];
      return e?.[`${targetField}_${currentCurrency}_TXT`] ?? e[targetField];
    },
    [theToolbarState.currentCurrency]
  );

  const toolbar__onCollectionFilterChanged = (e: any) => {
    const key = e?.value;
    if (key) {
      const nextState = {
        ...theToolbarState,
        trackCollectionFilter: key,
      } as any;
      run(() => eDispatchDatasetChange(nextState));
    }
  };

  const onCollectionFilterChanged = (e: any) => {
    const key = e?.value;
    if (key) {
      switch (key) {
        case "ALL": {
          ivTrackGridRef.current
            .instance()
            .columnOption("REST_DE_INCASAT", "selectedFilterOperation", "=");
          ivTrackGridRef.current
            .instance()
            .columnOption("REST_DE_INCASAT", "filterValue", null);
          break;
        }
        case "COLLECTED": {
          ivTrackGridRef.current
            .instance()
            .columnOption("REST_DE_INCASAT", "selectedFilterOperation", "<=");
          ivTrackGridRef.current
            .instance()
            .columnOption("REST_DE_INCASAT", "filterValue", "0");
          break;
        }
        case "UNCOLLECTED": {
          ivTrackGridRef.current
            .instance()
            .columnOption("REST_DE_INCASAT", "selectedFilterOperation", ">");
          ivTrackGridRef.current
            .instance()
            .columnOption("REST_DE_INCASAT", "filterValue", "0");
          break;
        }
        default:
          break;
      }
      toolbar__onCollectionFilterChanged(e);
    }
  };

  const newInvoiceBttnOptions = {
    icon: "add",
    type: "default",
    hint: t("new_invoice"),
    onClick: () => {
      dispatch(fxSelectInvoiceTab(appConst.EMenuCmdTab.CMD_BGIM_INVOICE));
    },
    visible: false, //appIsPersonalKarma,  we are not ready with thsis
  };

  const collectionFilterOptions = {
    icon: "money",
    hint: t("by_collection_status"),
    placeholder: t("any_collected_state"),
    stylingMode: "outlined",
    elementAttr: {
      id: "collectionFilter",
      class: theToolbarState.trackCollectionFilter,
      // class: 'dx-button-group-collectionfilter',
    },
    dataSource: [
      {
        text: t("any_collected_state"),
        value: "ALL",
        icon: "checklist",
        // className: "dx-button-group-collectionfilter all",
      },
      {
        text: t("cashed_invoices"),
        value: "COLLECTED",
        icon: "selectall",
        // className: "dx-button-group-collectionfilter collected",
      },
      {
        text: t("uncashed_invoices"),
        value: "UNCOLLECTED",
        icon: "unselectall",
        // className: "dx-button-group-collectionfilter uncollected",
      },
    ],
    valueExpr: "value",
    displayExpr: "text",
    useItemTextAsTitle: true,
    width: 95,
    useSelectMode: true,
    value: theToolbarState.trackCollectionFilter,
    onValueChanged: onCollectionFilterChanged,
  };

  const homeResetFiltersClick = useCallback(async (e: any) => {
    const { key } = e.itemData;
    if (key) {
      switch (key) {
        case "home": {
          run(function* () {
            //begin update
            ivTrackGridRef.current.instance().beginUpdate();

            //reset filters:
            onCollectionFilterChanged({ value: "ALL" });
            ivTrackGridRef.current.instance().clearFilter();
            // set current:
            dispatch(setViewToCurrentMonth());
            // select latest invoice

            yield* sleep(100);
            //end update

            const el = document.getElementById("homeResetFilters");
            if (el) {
              el.classList.remove("filtered");
            }

            ivTrackGridRef.current.instance().endUpdate();
          });

          break;
        }
        case "refresh": {
          // ivTrackGridRef.current.instance().refresh();
          break;
        }
        case "nofilter": {
          ivTrackGridRef.current.instance().clearFilter();
          ivTrackGridRef.current.instance().repaint();
          break;
        }
        default:
          break;
      }
    }
  }, []);

  const homeResetRefreshOptions = {
    activeStateEnabled: false,
    focusStateEnabled: false,
    hoverStateEnabled: true,
    selectionMode: "none",
    elementAttr: {
      id: "homeResetFilters",
      class: `${hrrref.current} ${isHomeInInterval ? "ishome" : ""}`,
    },
    items: [
      {
        key: "home",
        icon: "home",
        hint: t("home"),
        disabled: false,
      },
      {
        key: "nofilter",
        icon: '<svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 32 32"><path fill="currentColor" d="M30 11.414L28.586 10L24 14.586L19.414 10L18 11.414L22.586 16L18 20.585L19.415 22L24 17.414L28.587 22L30 20.587L25.414 16z"/><path fill="currentColor" d="M4 4a2 2 0 0 0-2 2v3.17a2 2 0 0 0 .586 1.415L10 18v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h-2v2h-4v-8.83l-.586-.585L4 9.171V6h20v2h2V6a2 2 0 0 0-2-2Z"/></svg>',
        hint: t("clear_filters"),
        disabled: false,
        elementAttr: {
          css: "dx-datagrid-filter-panel-clear-filter",
        },
      },
      // {
      //   key: "refresh",
      //   icon: "refresh",
      //   hint: t("refresh"),
      //   disabled: false,
      // }
    ],
    keyExpr: "key",
    stylingMode: "outlined",
    onItemClick: homeResetFiltersClick,
  };

  const onExpandCollapseClick = useCallback((e: any) => {
    const { key } = e.itemData;
    if (key) {
      switch (key) {
        case "expand_all": {
          if (ivTrackGridRef.current?.instance) {
            ivTrackGridRef.current.instance().expandAll();
          }
          break;
        }
        case "collapse_all": {
          collapseTree();
          break;
        }
        case "one_node": {
          /// POC
          if (ivTrackGridRef.current?.instance) {
            for (const key of ivTrackGridRef.current
              .instance()
              .getVisibleRows()) {
              if (key.rowType === "group") {
                if (key.key?.[0]) {
                  if (key.key[0].startsWith("ACME")) {
                    ivTrackGridRef.current.instance().collapseRow(key.key);
                  }
                }
              }
            }
          }
          break;
        }
        default:
          break;
      }
    }
  }, []);

  const expandCollapseOptions = {
    activeStateEnabled: false,
    focusStateEnabled: false,
    hoverStateEnabled: true,
    selectionMode: "single",
    elementAttr: {
      class: "dx-button-group-collectionfilter",
    },
    items: [
      {
        key: "expand_all",
        icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><g clip-path="url(#gravityUiChevronsExpandVertical0)"><path fill="#333" fill-rule="evenodd" d="M3.58 4.109a.75.75 0 0 0 1.061 1.06L8 1.811l3.354 3.353a.75.75 0 0 0 1.06-1.06L8.53.22a.75.75 0 0 0-1.06 0zm8.84 7.782a.75.75 0 1 0-1.061-1.06l-3.36 3.358l-3.353-3.353a.75.75 0 1 0-1.06 1.06L7.47 15.78a.75.75 0 0 0 1.06 0z" clip-rule="evenodd"/></g><defs><clipPath id="gravityUiChevronsExpandVertical0"><path fill="#333" d="M0 0h16v16H0z"/></clipPath></defs></g></svg>`,
        //  'expand',
        hint: t("expand_all"),
        disabled: false,
      },
      {
        key: "collapse_all",
        icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="#333" fill-rule="evenodd" d="M12.42 2.141a.75.75 0 1 0-1.061-1.06L8 4.439L4.646 1.086a.75.75 0 1 0-1.06 1.06L7.47 6.03a.75.75 0 0 0 1.06 0zM3.58 13.86a.75.75 0 0 0 1.061 1.06L8 11.561l3.354 3.353a.75.75 0 0 0 1.06-1.06L8.53 9.97a.75.75 0 0 0-1.06 0z" clip-rule="evenodd"/></svg>`,
        // 'collapse',
        hint: t("collapse_all"),
        disabled: false,
      },
    ],
    keyExpr: "key",
    stylingMode: "outlined",
    onItemClick: onExpandCollapseClick,
  };

  const rowPrepared = useCallback(
    (e: any) => {
      if (e.rowType === "data") {
        switch (true) {
          case e?.data.REST_DE_INCASAT <= 0: {
            theToolbarState.colorized
              ? e.rowElement.classList.add("collectedInvoiceBackground")
              : e.rowElement.classList.add("collectedInvoiceBackgroundMono");
            break;
          }
          case e?.data.REST_DE_INCASAT > 0: {
            theToolbarState.colorized
              ? e.rowElement.classList.add("overduedInvoiceBackground")
              : e.rowElement.classList.add("overduedInvoiceBackgroundMono");
            break;
          }
          default:
            break;
        }
      }
      if (e.rowType === "group") {
        theToolbarState.colorized
          ? e.rowElement.classList.add("groupInvoiceBackground")
          : e.rowElement.classList.add("groupInvoiceBackgroundMono");
      }
    },
    [theToolbarState.colorized]
  );

  const rowClick = (e: any) => {
    if (e.rowType === "group") {
      dispatch(
        setCurrentInvoiceMain2({
          CFF_ID: e.data.collapsedItems?.[0]?.CFFID || -1,
        })
      );

      //mark the group row as selected !
      groupKey.current = e.key;
    } else {
      if (e.rowType === "data") {
        // mark the parent group as selected
        groupKey.current = [e.data.CLIENT];
      }
    }

    // unselect all group cells
    const groupCells = e.element.querySelectorAll(".dx-group-cell-item");
    for (let i = 0; i < groupCells.length; i++) {
      const cell = groupCells[i];
      //compare the node's text with the key
      if (!cell.textContent) continue;
      // todeo: on fast click on other row after collection we have error on [0]
      // that is for workarround
      if (!e.key?.[0]) continue;

      if (cell.textContent === e.key[0]) {
        cell.classList.add("row-selected");
      } else {
        cell.classList.remove("row-selected");
      }
    }

    if (e.rowType === "group") {
      // deselect the selected invoice, if there is one
      selectionChanged({
        selectedRowsData: [
          {
            FF_ID: -1,
            ABR: "",
            MONEDA_FF: "RON",
            REST_DE_INCASAT: 0,
          },
        ],
      });
    }
    e.component.repaint();
  };

  const selectionChanged = (e: any) => {
    const { selectedRowsData } = e;
    if ((selectedRowsData || []).length > 0) {
      dispatch(setCurrentInvoiceMain(selectedRowsData[0]));
      ivTrackGridRef.current.instance().option("selectedRowKeys", [
        selectedRowsData[0].FF_ID, //sic (!)  -1 when group is selected
      ]); //impo
    }
  };

  const groupCellRender = (e: any) => {
    return (
      <div>
        <span
          className={`dx-group-cell-item ${
            e.key?.[0] && e.key?.[0] === groupKey.current?.[0]
              ? "row-selected"
              : ""
          }`}
        >
          {e.value}
        </span>
      </div>
    );
  };

  //TCallInvoice
  const doPrepareInvoice = useCallback(
    (ctxEvt: any, action: "edit" | "clone" | "storno" = "edit") => {
      const data = ctxEvt?.row;
      if (!data) return;
      if (!data?.rowType) return;
      //NOTE: FIXME: investigate ctx.key on thunk with full ctxEvt as payload -- might crash on deepSort!
      // this is not an issue for this proc. Karma or Jurnal, but a library possible issue.
      const obj = Object.assign(
        {},
        { data: data.data },
        { rowType: data.rowType }
      );
      dispatch(fxSelectInvoiceTabWithPayload({ data: obj, mode: action }));
    },
    []
  );

  const contextMenuPreparing = useCallback((e: any) => {
    if (!e.row) return;
    if (!appIsPersonalKarma) {
      dispatch(sfxNotify({ message: "To do.", type: "error" }));
      e.items = [];
      return;
    }
    try {
      const clientName =
        e.row?.rowType === "group" ? e.row.data?.items?.[0].CLIENT : "";
      const invoiceNo =
        e.row?.rowType === "group"
          ? ""
          : `${e.row.data?.NR_FF}/${formatDate(e.row.data?.LA_DATA)}`;
      e.items = [
        {
          text: "Editarea facturii",
          icon: "edit",
          visible: e.row.rowType === "data",
          onItemClick: (f) => doPrepareInvoice(e, "edit"),
        },
        {
          text:
            e.row.rowType === "group"
              ? `Factura noua pentru ${clientName}`
              : `Factura noua pornind de la ${invoiceNo}`,
          icon: "copy",
          onItemClick: (f) => doPrepareInvoice(e, "clone"),
          visible: e.row.rowType === "group", //disabled for invoice clone, work in progress
        },
        {
          text: "Stornare factura",
          icon: "trash",
          visible: e.row.rowType === "data",
          onItemClick: (f) => doPrepareInvoice(e, "storno"),
        },
      ];
    } catch (error) {
      console.log("error #1001: ", error, e);
      e.items = [];
    }
  }, []);

  const spvMessageIconClick = useCallback((e: any) => {
    dispatch(callFXMLDetailsForm(e.row.data));
  }, []);
  //note: do not change the "ivtrackgrid" name or add the changed one to the schemablue
  const loadState = useCallback(() => {
    return sendStorageRequest("uiPersistInvoiceGrid", "GET"); //ok
  }, [idbName]);

  const saveState = useCallback(
    (state) => {
      sendStorageRequest("uiPersistInvoiceGrid", "PUT", state);
    },
    [idbName]
  );

  // we aim to synchronize the selectbox of collected status with the grid filter
  // it kind of works..but will not implement it for now. not sure of all the implications
  function getFilterOfCollection(filterValue: string | string[]) {
    if (Array.isArray(filterValue)) {
      if (Array.isArray(filterValue[0])) {
        getFilterOfCollection(filterValue.shift());
        return;
      }
      if (filterValue[0] === "REST_DE_INCASAT") {
        if (filterValue[1] === "=") {
          if (filterValue[2] === "0") {
            return "COLLECTED";
          } else {
            return "UNCOLLECTED";
          }
        }
        if (filterValue[1] === "<=") {
          if (filterValue[2] === "0") {
            return "COLLECTED";
          }
        }
        if (filterValue[1] === ">") {
          if (filterValue[2] === "0") {
            return "UNCOLLECTED";
          }
        }
      }
    }
  }

  const filterValueChange = (e: any) => {
    if (!e) {
      toolbar__onCollectionFilterChanged({ value: "ALL" });
    }
    // const currentCollected = getFilterOfCollection(e);
    // console.log('currentCollected', currentCollected);

    const el = document.getElementById("homeResetFilters");
    if (el) {
      hrrref.current = e
        ? "dx-button-group-homeresetfilters filtered"
        : "dx-button-group-homeresetfilters";
    }
    ivTrackGridRef.current.instance().repaint();
  };

  const optionChanged = (e: any) => {
    if (e.name === "filterValue") {
      filterValueChange(e.value);
    }
  };

  const attributes = useMemo(
    () => ({ "data-currency": theToolbarState.currentCurrency }),
    [theToolbarState.currentCurrency]
  );

  const statusColCellRender = (e: any) => (
    <button
      className={`dx-icon dx-icon-message ${(e.value || "").toLowerCase()}`}
      onClick={() => spvMessageIconClick(e)}
    />
  );

  function* effSyncElements(): Operation<void> {
    if (ivTrackGridRef.current?.instance) {
      ivTrackGridRef.current.instance().beginUpdate();
      ivTrackGridRef.current
        .instance()
        .columnOption("LA_DATA", "filterValue", null);

      ivTrackGridRef.current.instance().endUpdate();
    }
    yield* sleep(1);
  }

  useEffect(() => {
    run(effSyncElements);
  }, [reference0]);

  return (
    <React.Fragment>
      <DataGrid
        elementAttr={attributes}
        id={"InvoiceOverallGrid"}
        ref={ivTrackGridRef}
        showBorders={true}
        height={jgDrawerHeight}
        className="dx-swatch-catetory-chooser-compact ivtgrid borderlessGrid"
        dataSource={dataSource}
        filterSyncEnabled={true}
        allowColumnReordering={true}
        allowColumnResizing={true}
        showRowLines={true}
        showColumnLines={true}
        repaintChangesOnly={true}
        renderAsync={false}
        onRowPrepared={rowPrepared}
        wordWrapEnabled={true}
        onRowClick={rowClick}
        onSelectionChanged={selectionChanged}
        onContextMenuPreparing={contextMenuPreparing}
        onFilterValueChange={filterValueChange}
        onOptionChanged={optionChanged}
      >
        <Paging enabled={true} defaultPageSize={70} />
        <Editing
          allowAdding={false}
          allowUpdating={false}
          allowDeleting={false}
        />
        <Selection mode="single" deferred={false} />
        <ColumnChooser enabled={true} />
        <SearchPanel visible={true} />
        <HeaderFilter visible={true} />
        <Grouping
          autoExpandAll={true}
          contextMenuEnabled={false}
          expandMode="buttonClick"
          allowCollapsing={true}
          // ref={groupingRef}
        />
        <StateStoring
          enabled={true}
          type="custom"
          customLoad={loadState}
          customSave={saveState}
        />
        <GroupPanel visible={true} allowColumnDragging={false} />
        <FilterPanel visible={true} />
        <LoadPanel enabled={false} />
        <Scrolling mode="virtual" rowRenderingMode="virtual" />
        <Toolbar>
          <Item
            location="before"
            widget="dxSelectBox"
            {...(EmitentPickerOpts(
              issuers,
              theToolbarState.selectedCIF,
              onEmitentChanged
            ) as any)}
          />
          <Item
            location="before"
            widget="dxSelectBox"
            {...(CurrencyPickerOpts(
              currencies,
              theToolbarState.currentCurrency as TCurrency,
              onCurrencyChanged
            ) as any)}
          />
          <Item location="before" name="groupPanel" />
          <Item
            location="before"
            widget="dxSelectBox"
            options={collectionFilterOptions}
          />
          <Item
            location="before"
            widget="dxButton"
            options={newInvoiceBttnOptions}
          />
          <Item
            location="center"
            widget="dxButtonGroup"
            options={homeResetRefreshOptions}
            locateInMenu="auto"
          />
          <Item location="center" name="searchPanel" />
          <Item
            location="center"
            widget="dxButtonGroup"
            options={expandCollapseOptions}
            locateInMenu="auto"
          />
          <Item
            location="after"
            name="columnChooserButton"
            locateInMenu="auto"
          />
          <Item
            location="after"
            widget="dxButtonGroup"
            options={colorizedOptions}
            locateInMenu="auto"
          />
        </Toolbar>
        <Column
          dataField="FF_ID"
          name="FFID001"
          caption=""
          allowFiltering={false}
          cellRender={(e) => <React.Fragment />}
        ></Column>
        <Column
          dataField="EFFX_STATUS"
          cssClass="effx-status"
          caption=""
          allowFiltering={true}
          width={30}
          visible={true}
          renderAsync={true}
          cellRender={statusColCellRender}
        />

        <Column
          name="buttons2"
          type="buttons"
          width={40}
          visible={false}
          renderAsync={true}
        >
          <Button hint="Clone" icon="repeat" />
        </Column>

        <Column dataField="FF_ID" {...(fieldDefs["FF_ID"] as any)} />
        <Column
          /*
          if the first collumn is of a fixed width the grid will 
          do a header flicker on state change, 
          so make it auto (undefined)
          */
          dataField="NR_FF"
          {...(fieldDefs["NR_FF"] as any)}
          allowGrouping={false}
          alignment="right"
          visible={true}
          cssClass={"dx-column-highlight"}
        />
        <Column
          dataField="LA_DATA"
          {...(fieldDefs["LA_DATA"] as any)}
          allowGrouping={false}
          cssClass={"dx-column-highlight"}
        />
        <Column
          dataField="CLIENT"
          {...(fieldDefs["CLIENT"] as any)}
          groupIndex={0}
          allowFiltering={true}
          groupCellRender={groupCellRender}
        />
        <Column
          dataField="C_ID"
          {...(fieldDefs["C_ID"] as any)}
          width={150}
          minWidth={150}
        />
        <Column
          dataField="CFFID"
          {...(fieldDefs["CFFID"] as any)}
          width={150}
          minWidth={150}
        />
        <Column
          dataField="FE_ID"
          {...(fieldDefs["FE_ID"] as any)}
          width={150}
          minWidth={150}
        />
        <Column
          dataField="FE_NR"
          {...(fieldDefs["FE_NR"] as any)}
          width={150}
          minWidth={150}
          allowGrouping={false}
        />
        <Column
          dataField="VAL_TXT"
          {...(fieldDefs["VAL_TXT"] as any)}
          width={150}
          minWidth={150}
          allowGrouping={false}
          // visible={false}
        />
        <Column
          dataField="VAL_TXT_CONV"
          calculateCellValue={(e) => calculateConvValue(e, "VAL")}
          visible={false}
        />

        <Column
          dataField="VAL_TVA_TXT"
          {...(fieldDefs["VAL_TVA_TXT"] as any)}
          width={150}
          minWidth={150}
          allowGrouping={false}
          // visible={false}
        />
        <Column
          dataField="VAL_TVA_TXT_CONV"
          calculateCellValue={(e) => calculateConvValue(e, "VAL_TVA")}
          visible={false}
        />

        <Column
          dataField="TOTAL_TXT"
          {...(fieldDefs["TOTAL_TXT"] as any)}
          width={150}
          minWidth={150}
          allowGrouping={false}
        />
        <Column
          dataField="TOTAL_TXT_CONV"
          calculateCellValue={(e) => calculateConvValue(e, "TOTAL")}
          visible={false}
        />
        <Column
          dataField="INCASAT_TXT"
          {...(fieldDefs["INCASAT_TXT"] as any)}
          width={150}
          minWidth={150}
          allowGrouping={false}
        />
        <Column
          dataField="INCASAT_TXT_CONV"
          calculateCellValue={(e) => calculateConvValue(e, "INCASAT")}
          visible={false}
        />
        <Column
          dataField="REST_DE_INCASAT_TXT"
          {...(fieldDefs["REST_DE_INCASAT_TXT"] as any)}
          width={150}
          minWidth={150}
          allowGrouping={false}
          allowHeaderFiltering={true}
        />
        <Column
          dataField="REST_DE_INCASAT_TXT_CONV"
          calculateCellValue={(e) => calculateConvValue(e, "REST_DE_INCASAT")}
          visible={false}
        />
        <Column
          dataField="VAL"
          {...(fieldDefs["VAL"] as any)}
          visible={false}
        />
        <Column
          dataField="VAL_TVA"
          {...(fieldDefs["VAL_TVA"] as any)}
          visible={false}
        />
        <Column
          dataField="TOTAL"
          {...(fieldDefs["TOTAL"] as any)}
          visible={false}
        />
        <Column
          dataField="INCASAT"
          {...(fieldDefs["INCASAT"] as any)}
          visible={false}
        />
        <Column
          dataField="REST_DE_INCASAT"
          {...(fieldDefs["REST_DE_INCASAT"] as any)}
          visible={false}
        />

        <Column
          dataField="MONEDA_FF"
          {...(fieldDefs["MONEDA_FF"] as any)}
          visible={false}
        />

        <Column
          dataField="NR_FE"
          {...(fieldDefs["NR_FE"] as any)}
          visible={false}
        />
        <Column
          dataField="ANULATA"
          {...(fieldDefs["ANULATA"] as any)}
          visible={false}
        />
        <Column
          dataField="ARE_FLID"
          {...(fieldDefs["ARE_FLID"] as any)}
          visible={false}
        />
        <Column
          dataField="DATA_INC"
          {...(fieldDefs["DATA_INC"] as any)}
          visible={true}
          //   width={150}
          alignment="center"
          allowGrouping={false}
        />
        <Column
          dataField="INCAS_FF_FARA_TVA"
          {...(fieldDefs["INCAS_FF_FARA_TVA"] as any)}
          visible={false}
        />
        <Column
          dataField="INCAS_FF_TVA"
          {...(fieldDefs["INCAS_FF_TVA"] as any)}
          visible={false}
        />
        <Column
          dataField="LOCATIE"
          {...(fieldDefs["LOCATIE"] as any)}
          visible={false}
        />
        <Column
          dataField="FISIER"
          {...(fieldDefs["FISIER"] as any)}
          visible={false}
        />
        <Column
          dataField="ABR"
          {...(fieldDefs["ABR"] as any)}
          visible={false}
        />

        <Summary calculateCustomSummary={calculateTotalValuesConv}>
          <GroupItem
            {...groupCustomItemConv({ name: "VAL_TXT_CONV" })}
            summaryType="custom"
          />
          <GroupItem
            {...groupCustomItemConv({ name: "VAL_TVA_TXT_CONV" })}
            summaryType="custom"
          />
          <GroupItem
            {...groupCustomItemConv({ name: "TOTAL_TXT_CONV" })}
            summaryType="custom"
          />
          <GroupItem
            {...groupCustomItemConv({ name: "INCASAT_TXT_CONV" })}
            summaryType="custom"
          />
          <GroupItem
            {...groupCustomItemConv({ name: "REST_DE_INCASAT_TXT_CONV" })}
            summaryType="custom"
          />
          <GroupItem
            {...groupCustomItem({ name: "DATA_INC" })}
            summaryType="max"
            customizeText={(e) => {
              if (isSameDay(new Date(e.value), new Date(1970, 0, 1))) return "";
              return e.valueText;
            }}
          />
          <TotalItem
            {...totalsCount({ name: "NR_FF", label: "Facturi" })}
            summaryType="count"
          />
          <TotalItem
            {...groupCustomTotalsConv({ name: "VAL_TXT_CONV", label: "" })}
            summaryType="custom"
          />
          <TotalItem
            {...groupCustomTotalsConv({ name: "VAL_TVA_TXT_CONV", label: "" })}
            summaryType="custom"
          />
          <TotalItem
            {...groupCustomTotalsConv({ name: "TOTAL_TXT_CONV", label: "" })}
            summaryType="custom"
          />
          <TotalItem
            {...groupCustomTotalsConv({ name: "INCASAT_TXT_CONV", label: "" })}
            summaryType="custom"
          />
          <TotalItem
            {...groupCustomTotalsConv({
              name: "REST_DE_INCASAT_TXT_CONV",
              label: "",
            })}
            summaryType="custom"
          />
          <TotalItem
            {...groupCustomTotals({ name: "DATA_INC", label: "" })}
            summaryType="max"
            customizeText={(e) => {
              if (isSameDay(new Date(e.value), new Date(1970, 0, 1))) return "";
              return e.valueText;
            }}
          />
        </Summary>
      </DataGrid>
      {/* <ContextMenu
        dataSource={[{ text: "Clone_x" }]}
        width={200}
        target="#ivTrackGridRef .dx-link.dx-icon-overflow"
        // itemRender={ItemTemplate}
        // onItemClick={itemClick}
      /> */}
    </React.Fragment>
  );
};
